<template>
  <div class="l-row">

    <loader :loading="loading"/>

    <form-group :label="$t('category.label')">
      <input class="form-select" v-model="item.from.category" :columns="3" readonly="readonly">
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group :label="$t('category.label')" :columns="3">
      <input v-model="category" class="form-select" readonly="readonly">
    </form-group>

    <slot/>
  </div>
</template>

<script>
  import api from '@/api'
  import notifier from '@/notifier'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Loader from '@/components/template/Loader'

  export default {
    data: () => ({
      category: null,
      loading: false
    }),
    props: {
      preset: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      this.loading = true
      try {
        this.category = (await api.getCategories(this.preset.to.module.type, this.preset.to.module.identifier)).find(category => category.code === this.item.to.category).label
      } catch (e) {
        notifier.error('Impossível carregar as categorias da GFG.', 'Erro')
      } finally {
        this.loading = false
      }
    },
    components: {
      Panel,
      FormGroup,
      Loader
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

    .vertical-center
      display: flex
      align-items: center
      min-height: 81px
</style>



// WEBPACK FOOTER //
// CategorizationItem.vue?c713677e